/**
 * Created by Daniela on 23/01/2017.
 */
export class Tanque {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    identificacao: string;
    numeroPatrimonio: string;
    capacidade: number;
    localId: number;
    combustivelId: number;
    statusAmarelo: number;
    statusVermelho: number;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}

export class MovimentacaoTanque {
    ativo: boolean;
    dataCriacao: string;
    dataUltimaAlteracao: string;
    data: string;
    quantidade: number;
    odometroHorimetro: number;
    tipoLancamento: number;
    notaFiscal: string;
    af: string;
    documento: string;
    observacao: string;
    motivo: string;
    bemId: number;
    bombaId: number;
    combustivelId: number;
    funcionarioId: number;
    localId: number;
    tanqueId: number;
    tanqueDestinoId: number;
    tipoAjusteId: number;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}

export class MovimentacaoTanqueArea {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    quantidade: number;
    areaId: number;
    movimentacaoId: number;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/shared/tanque.model.ts
 **/